import { render, staticRenderFns } from "./StudentFilter.vue?vue&type=template&id=196216c9&scoped=true&"
import script from "./StudentFilter.vue?vue&type=script&lang=js&"
export * from "./StudentFilter.vue?vue&type=script&lang=js&"
import style0 from "./StudentFilter.vue?vue&type=style&index=0&id=196216c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196216c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect})
